import { signOut } from 'firebase/auth';
import { auth } from '../../auth/lib/firebase';

export const handleNativeLogoutResponse = (payload: unknown) => {
  // @TODO: Evaluate if this is needed.
  console.log('LOGOUT_RESPONSE', payload);
  signOut(auth);
};
